import api from './api';

const specialInventoryService = {
    getLocalProducts: async () => {
        const response = await api.get('/inventory-management/local-products');
        return response.data;
    },

    createLocalProduct: async (productData) => {
        const response = await api.post('/inventory-management/local-products', productData);
        return response.data;
    },

    updateLocalProduct: async (id, productData) => {
        const response = await api.put(`/inventory-management/local-products/${id}`, productData);
        return response.data;
    },

    getLocalProductsStats: async () => {
        const response = await api.get('/inventory-management/local-products/stats');
        return response.data;
    },

    updateStock: async (id, payload) => {
        const response = await api.post(`/inventory-management/local-products/${id}/stock`, payload);
        return response.data;
    }
};

export default specialInventoryService;
